module.exports = __webpack_public_path__ + "static/logo10-5c41cd83f76586fbe3e0b42b06d9cca6.png";